import { BenefitType } from "../enums/BenefitType";
import { UploadedDocument } from "../domain/UploadedDocument";

export type HospitalIndemnityFormValues = {
    documents: UploadedDocument[],
}

export const defaultHospitalIndemnityFormValues = {
    benefit: BenefitType.HOSPITAL_INDEMNITY,
    hospitalIndemnity: true,
    documents: [{
        document: '',
        documentContent: '',
        documentType: ''
    }],
}